exports.from =
  Buffer.from ||
  function(value, encoding) {
    if (encoding) {
      return new Buffer(value, encoding);
    }
    return new Buffer(value);
  };

exports.alloc =
  Buffer.alloc ||
  function(size) {
    return new Buffer(size);
  };



//////////////////
// WEBPACK FOOTER
// ./~/mock-fs/lib/buffer.js
// module id = 175
// module chunks = 0 1 2 3